export const SETLOADING = "SETLOADING";

export const UPDATEAPITOKENS = 'UPDATEAPITOKENS';

export const UPDATEDETAILS = "UPDATEDETAILS";

export const SETUSER = "SETUSER";

export const UPDATEUSER = "UPDATEUSER";